export class SubscribeRoutingPath {
  static readonly SUBSCRIBE_DOCUMENT = 'subscribe/:token';
  static readonly SUBSCRIBE = 'subscribe';
}
